import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Pagination, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaRegUserCircle } from "react-icons/fa";
import AddDoctors from "./addDoctors";
import UploadDoctorsCsvFile from "./uploadDoctorsCsv";
import DoctorCsvFormat from "./doctorCsvFormat";
import "./hm-theme.css";

function CompanyDoctorsDetails({ selectedOrgcode }) {
  const [doctorsDetails, setDoctorsDetails] = useState([]);
  const [loading, setLoading] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCsvUplaodModalOpen, setIsCsvUplaodModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [company, setCompany] = useState(null);

  const token = JSON.parse(localStorage.getItem("data"))?.token;
  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);  
    } else {
      getData(currentPage);   
    }
  }, [searchTerm]); 

  const searchData = async (pageNumber = 0) => {
    setLoading(true);
    try {
      const searchUrl = `/api/doctordetails/searchByNameOrEmail`;
      const requestData = {
        searchTerm,
        companyId: company?.id
      };
      
      const response = await axios.post(searchUrl, requestData, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });
      setDoctorsDetails(response.data.content || []);
      setCurrentPage(response.data.number || 0);
      setTotalPages(response.data.totalPages || 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoading(true);
    try {  
      const compRes = await axios.get(`/api/companydetails/companycode=${selectedOrgcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompany(compRes.data);
      const trans = await axios.get(`/api/doctordetails/companyId=${compRes.data?.id}`, {
        params: { page: pageNumber }, 
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setDoctorsDetails(trans.data.content || []);
      setCurrentPage(trans.data.number || 0);
      setTotalPages(trans.data.totalPages || 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  function onClickhandler(e, id, disabled) {
    setLoading(true);
    axios.post(`/api/doctordetails/update`, {
      id: id,
      disabled: disabled
    }, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        setLoading(false);
        toast.success("Status updated successfully");
        if (searchTerm.trim()) {
          searchData(currentPage);
        } else {
          getData(currentPage);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error);
      });
  }

  const handleAddEmployee = () => { setIsModalOpen(true); };
  const handleCloseModal = () => { setIsModalOpen(false); getData(); };

  const handleUploadEmployeeCsv = () => { setIsCsvUplaodModalOpen(true); };
  const handleCloseUploadCsvModal = () => { setIsCsvUplaodModalOpen(false); getData(); };

  const openUserProfileModal = async (userid) => {
    navigate(`/users/doctor-profile/${userid}`);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);
    if (currentPage <= 2) endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    if (currentPage >= totalPages - 3) startPage = Math.max(0, totalPages - maxPageNumbersToShow);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const [showImageModal, setShowImageModal] = useState(false);
  const handleShowImageModal = () => setShowImageModal(true);
  const handleCloseImageModal = () => setShowImageModal(false);

  return (
    <div>
      {loading && <div className="loading"></div>}

      <div className="hm-card">
        {/* Header */}
        <div className="hm-card-header">
          <h3 className="hm-card-title">
            <i className="material-icons">medical_services</i>
            Doctors Details
          </h3>
          <div className="d-flex align-items-center gap-2">
            <button className="btn btn-outline-primary rounded-pill px-3" onClick={handleShowImageModal}>
              View Format
            </button>
            <button className="btn btn-outline-secondary rounded-pill px-3" onClick={handleUploadEmployeeCsv}>
              Upload CSV
            </button>
            <button className="btn-hm-primary" onClick={handleAddEmployee}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>add</i>
              Add Doctor
            </button>
          </div>
        </div>

        {/* Card Body */}
        <div className="hm-card-body p-4">
          {/* Search Row */}
          <div className="row mb-4">
            <div className="col-md-6 col-lg-5">
              <div className="position-relative">
                <input
                  type="search"
                  className="form-control ps-4"
                  placeholder="Search doctor by Name or Email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="material-icons position-absolute text-muted" style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "1.1rem" }}>
                  search
                </i>
              </div>
            </div>
          </div>

          {/* Doctor Cards Grid */}
          {doctorsDetails.length === 0 ? (
            <div className="hm-empty-state">
              <i className="material-icons">group_off</i>
              <p>No Doctors Found</p>
            </div>
          ) : (
            <Row className="g-3">
              {doctorsDetails.map((accd) => (
                <Col key={accd.id} md={6} lg={4}>
                  <div
                    className="hm-card h-100 p-3 position-relative transition-all"
                    style={{ cursor: "pointer" }}
                    onClick={() => openUserProfileModal(accd.userid)}
                    title="View Doctor Profile"
                  >
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className={accd.disabled === false ? "hm-badge hm-badge-success" : "hm-badge hm-badge-danger"}>
                        {accd.disabled === false ? "Active" : "Disabled"}
                      </span>
                      <div className="form-check form-switch m-0" onClick={(e) => e.stopPropagation()}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          checked={accd.disabled === false}
                          style={{ cursor: "pointer" }}
                          onChange={(e) => onClickhandler(e, accd.id, !accd.disabled)}
                          title="Toggle Doctor Status"
                        />
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                      <div className="flex-shrink-0">
                        {accd.doctorProfileImage?.image ? (
                          <img
                            src={`${accd.doctorProfileImage?.imageMeta},${accd.doctorProfileImage?.image}`}
                            alt={accd.doctorName}
                            className="rounded-circle border shadow-sm"
                            style={{ width: "64px", height: "64px", objectFit: "cover" }}
                          />
                        ) : (
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center bg-light text-primary"
                            style={{ width: "64px", height: "64px", fontSize: "36px" }}
                          >
                            <FaRegUserCircle />
                          </div>
                        )}
                      </div>
                      <div className="overflow-hidden">
                        <h6 className="fw-bold mb-1 text-truncate text-dark">{accd.doctorName}</h6>
                        <p className="text-muted small mb-1 text-truncate">
                          <i className="material-icons align-middle me-1" style={{ fontSize: "14px" }}>email</i>
                          {accd.email || "—"}
                        </p>
                        <p className="text-muted small mb-0 text-truncate">
                          <i className="material-icons align-middle me-1" style={{ fontSize: "14px" }}>phone</i>
                          {accd.phoneNumber || "—"}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center pt-4">
              <Pagination className="hm-pagination">
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage >= totalPages - 1} />
              </Pagination>
            </div>
          )}
        </div>
      </div>

      {isModalOpen && (
        <AddDoctors isOpen={isModalOpen} onRequestClose={handleCloseModal} companyId={company?.id}/>
      )}
      {isCsvUplaodModalOpen && (
        <UploadDoctorsCsvFile isOpen={isCsvUplaodModalOpen} onRequestClose={handleCloseUploadCsvModal} companyId={company?.id} companycode={company?.companycode}/>
      )}
      {showImageModal && (
        <DoctorCsvFormat isOpen={showImageModal} onRequestClose={handleCloseImageModal} />
      )}
    </div>
  );
}

export default CompanyDoctorsDetails;

